<template>
    <div class="main_body">
        <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
        <div class="container-fluid">
            <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
                <div style="margin-left:20px;" class="pb-4">
                <h3>Most Purchased Audiobook</h3>
            </div>
            </div>
            <div>
                <table class="table" style="">
                <thead>
                    <tr width:30px>
                        <th>No</th>
                        <th>Name</th>
                        <th>Author Name</th>
                        <th>Contributing Artist</th>
                        <th>Price</th>
                        <th>Discount Price</th>
                        <!-- <th>Guide</th> -->
                        <th>Publish Year</th>
                        <th>Image</th>
                        <!-- <th>Banner</th> -->
                        <th>Premium</th>
                        <th>Approval Status</th>
                        <th>Play Count</th>
                        <!-- <th>For App</th> -->
                        <!-- <th>Deleted</th> -->
                        <th>Total purchase</th>
                        <!-- <th>Category ID</th> -->
                        <!-- <th>Channel ID</th> -->
                        <!-- <th>Podcast</th> -->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data, index) in purchasedAudio" :key="index">
                    <td>{{index+1}}</td>
                        <td>{{ data.name }}</td>
                        <td>{{ data.author_name }}</td>
                        <td>{{ data.contributing_artists }}</td>
                        <td>{{ data.price }}</td>
                        <td>{{ data.discount_price }}</td>
                        <!-- <td>{{ data.guid }}</td> -->
                        <td>{{ data.publish_year }}</td>
                        <td><img style="width:60%;" :src="data.thumb_path" alt=""></td>
                        <!-- <td><img width="100%" :src="data.banner_path" alt=""> </td> -->
                        <td>{{ data.premium }}</td>
                        <td>{{ data.approval_status }}</td>
                        <td>{{ data.play_count }}</td>
                        <!-- <td>{{ data.for_app }}</td> -->
                        <!-- <td>{{ data.deleted }}</td> -->
                        <!-- <td>{{ data.category_id }}</td> -->
                        <!-- <td>{{ data.channel_id }}</td> -->
                        <!-- <td>{{ data.podcast }}</td> -->
                        <td>{{data.total_sell}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import axios from "axios";
export default {
    data() {
        return {
            purchasedAudio: "",
            isLoading: false,
            fullPage: true,
            loader: "bars",
        }
    },

    components:{
        Loading
    },

    created() {
        this.list()
    },
    methods: {
        async list() {
            const token = localStorage.getItem(this.$tokenKey);
            try {
                this.isLoading = true
                const res = await axios.get(
                    this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/audiobook-most-purchased", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                }
                );
                if (res.status == 200) {
                    // console.log(res)
                    this.purchasedAudio = res.data
                    this.isLoading = false
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
    }
}
</script>